import { combineReducers } from '@ngrx/store';
import { showRecessions } from 'TargetRatesApp/apps/target-rates-app/state/show-recessions/show-recessions.reducer';
export const targetRates = combineReducers({
    showRecessions,
});
